<template>
  <el-dialog
    title="质检记录单"
    :visible="visible"
    width="600px"
    class="quality-inspection-dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
    :destroy-on-close="true"
    :append-to-body="true"
    @close="onClose"
  >
    <div class="quality-inspection-entry">
      <div class="form-section">
        <div class="form-row">
          <div class="form-field">
            <p class="form-field-title">质检类型：</p>
            <el-radio-group v-model="qualityInspectionData.inspectionType" class="inspection-type-radio">
              <el-radio :label="1">回库质检</el-radio>
              <el-radio :label="2">出库质检</el-radio>
            </el-radio-group>
          </div>
        </div>

        <div class="form-row">
          <div class="form-field">
            <p class="form-field-title">质检记录：</p>
            <el-input
              v-model="qualityInspectionData.inspectionRecord"
              type="textarea"
              placeholder="请详细记录质检过程和结果"
              class="form-field-textarea"
              :rows="4"
            >
            </el-input>
          </div>
        </div>

        <div class="form-row">
          <div class="form-field">
            <p class="form-field-title">上传图片：</p>
            <div class="upload-images-container">
              <el-upload
                v-show="uploadFiles.length < 3"
                :action="''"
                :before-upload="beforeUpload"
                :on-success="handleUploadSuccess"
                :on-error="handleUploadError"
                :file-list="[]"
                :auto-upload="true"
                class="upload-images"
              >
                <div class="upload-images-add">
                  <i class="upload-image-add-icon">+</i>
                  <span class="upload-image-add-text">上传图片</span>
                </div>
              </el-upload>
              <div class="upload-images-list">
                <div
                  v-for="(file, index) in uploadFiles"
                  :key="index"
                  class="upload-image-item"
                >
                  <div class="upload-image-preview">
                    <img v-if="file.type.startsWith('image/')" :src="file.url" alt="质检图片" />
                    <img v-else-if="file.type.startsWith('video/')" src="@/assets/imgs/device_file_video.png" alt="视频图标" />
                  </div>
                  <div class="upload-image-name">{{ file.name }}</div>
                  <div class="upload-image-actions">
                    <i class="el-icon-delete" @click="handleDelete(index)"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" :disabled="loading" @click="onSubmitFault">提故障</el-button>
      <el-button type="primary" :loading="loading" :disabled="loading" @click="onSubmitComplete">无问题,质检完成</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { Dialog, RadioGroup, Radio, Input, Upload, Button } from "element-ui";

export default {
  name: "QualityInspectionEntry",
  
  components: {
    ElDialog: Dialog,
    ElRadioGroup: RadioGroup,
    ElRadio: Radio,
    ElInput: Input,
    ElUpload: Upload,
    ElButton: Button,
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    deviceData: {
      type: Object,
      default: () => ({})
    }
  },

  data: function () {
    return {
      qualityInspectionData: {
        inspectionType: 1, // 默认回库质检
        inspectionRecord: "",
      },
      uploadFiles: [], // 存储已上传的文件信息
      loading: false, // 提交loading状态
    };
  },

  watch: {
    visible(newVal) {
      if (newVal) {
        this.resetForm();
      }
    }
  },

  methods: {
    resetForm() {
      this.qualityInspectionData = {
        inspectionType: 1,
        inspectionRecord: "",
      };
      this.uploadFiles = [];
      this.loading = false;
    },

    // 上传前处理
    beforeUpload(file) {
      // 检查文件类型
      const isImageOrVideo = file.type.startsWith('image/') || file.type.startsWith('video/');
      if (!isImageOrVideo) {
        this.$toast.showRed('只能上传图片或视频文件');
        return false;
      }
      // 手动上传
      this.uploadFile(file);
      return false;
    },
    
    // 手动上传文件
    async uploadFile(file) {
      try {
        // 构造formData
        const formData = new FormData();
        formData.append('file', file);
        formData.append('fileName', file.name);
        
        // 调用上传接口
        const response = await this.$api.uplodFileWithNameRequest(formData);
        
        // 添加到已上传文件列表
        this.uploadFiles.push({
          name: file.name,
          type: file.type,
          url: response // 根据响应拦截器，成功响应会直接返回data.data，所以使用response
        });
        
        this.$toast.showGreen('上传成功');
      } catch (error) {
        this.$toast.showRed('上传失败：' + error);
        console.error('文件上传失败:', error);
      }
    },
    
    // 处理上传成功
    handleUploadSuccess(response, file) {
      // 这个方法在使用action属性时会被调用，这里我们使用手动上传，所以可能不会用到
    },
    
    // 处理上传失败
    handleUploadError(error, file) {
      this.$toast.showRed('上传失败：' + error);
    },
    
    // 删除已上传的文件
    handleDelete(index) {
      this.uploadFiles.splice(index, 1);
    },

    onClose() {
      this.$emit('close');
    },

    onSubmitFault() {
      // 通知父组件打开故障处理弹框
      this.$emit("openFaultDialog", this.deviceData);
      // 关闭当前质检弹框
      this.onClose();
    },

    async onSubmitComplete() {
      this.loading = true;
      
      try {
        // 构造API参数
        const params = {
          deviceArchivesId: this.deviceData.id,
          inspectionType: this.qualityInspectionData.inspectionType,
          inspectionRecord: this.qualityInspectionData.inspectionRecord,
          inspectionImages: this.uploadFiles.map(file => file.url).join(',') // 多个文件URL用逗号分隔
        };
        
        // 调用质检完成API
        await this.$api.completeQualityInspection(params);
        
        this.$toast.showGreen('质检完成成功');
        
        // 关闭弹框
        this.onClose();
        
        // 通知父组件质检完成并关闭设备档案窗口
        this.$emit('submitComplete', {
          deviceId: this.deviceData.id,
          inspectionType: this.qualityInspectionData.inspectionType,
          inspectionRecord: this.qualityInspectionData.inspectionRecord,
          inspectionImages: this.uploadFiles.map(file => file.url).join(',')
        });
      } catch (error) {
        console.error('质检完成失败:', error);
        this.$toast.showRed(error || '质检完成失败');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.quality-inspection-entry {
  width: 100%;

  .form-section {
    padding: rem(10) 0;
  }

  .required {
    color: #ff4d4f;
  }

  .form-row {
    display: flex;
    gap: rem(20);
    margin-bottom: rem(20);

    .form-field {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
        font-size: rem(14);
      }

      .inspection-type-radio {
        ::v-deep .el-radio {
          margin-right: rem(20);
        }
      }

      &-textarea {
        ::v-deep .el-textarea__inner {
          min-height: rem(80);
          font-family: inherit;
          border-radius: rem(6);
          border: rem(1) solid #e1e5e9;
          transition: border-color 0.2s, box-shadow 0.2s;

          &:focus {
            border-color: #325FAC;
            box-shadow: 0 0 0 rem(2) rgba(50, 95, 172, 0.1);
          }

          &:hover {
            border-color: #325FAC;
          }
        }
      }

      .upload-images-container {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        gap: rem(10);
        
        .upload-images {
          display: inline-block;
          
          .upload-images-add {
            width: rem(100);
            height: rem(100);
            border: 2px dashed #d9d9d9;
            border-radius: rem(4);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            color: #666;
            transition: all 0.3s;

            &:hover {
              border-color: #325FAC;
              color: #325FAC;
            }

            .upload-image-add-icon {
              font-size: rem(24);
              margin-bottom: rem(4);
            }

            .upload-image-add-text {
              font-size: rem(12);
            }
          }
        }

        .upload-images-list {
          display: flex;
          flex-wrap: wrap;
          gap: rem(10);

          .upload-image-item {
            position: relative;
            width: rem(100);
            height: rem(100);
            border: 1px solid #eee;
            border-radius: rem(4);
            overflow: hidden;
            background-color: #fafafa;

            .upload-image-preview {
              width: 100%;
              height: rem(80);
              overflow: hidden;

              img {
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }

            .upload-image-name {
              height: rem(20);
              line-height: rem(20);
              font-size: rem(12);
              text-align: center;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .upload-image-actions {
              position: absolute;
              top: 0;
              right: 0;
              background-color: rgba(0, 0, 0, 0.5);
              color: white;
              cursor: pointer;
              padding: rem(4);

              i {
                font-size: rem(12);
              }
            }
          }
        }
      }
    }
  }
}

// 弹框样式
::v-deep .quality-inspection-dialog {
  .el-dialog__header {
    background-color: #f8f9fa;
    border-bottom: rem(1) solid #e8e8e8;
    padding: rem(20) rem(24);

    .el-dialog__title {
      font-size: rem(16);
      font-weight: 500;
      color: rgba($color: black, $alpha: 0.85);
    }
  }

  .el-dialog__body {
    padding: rem(24);
  }

  .dialog-footer {
    text-align: right;
    padding: rem(16) rem(24) rem(24);
    border-top: rem(1) solid #e8e8e8;

    .el-button {
      margin-left: rem(12);
      border-radius: rem(6);
      font-size: rem(14);
      padding: rem(10) rem(24);
      font-weight: 500;

      &:first-child {
        margin-left: 0;
      }

      &--primary {
        background-color: #325FAC;
        border-color: #325FAC;

        &:hover {
          background-color: #2a4f96;
          border-color: #2a4f96;
        }
      }
    }
  }
}
</style>